import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";
import { Mail, Phone, ArrowUpRight } from "lucide-react";
import LogoMark from "@/components/LogoMark";

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid={TID.footer}
      className="bg-[color:var(--gc-navy)] text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 gc-grid-bg-dark opacity-50 pointer-events-none" />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <LogoMark className="h-10 w-auto" dark />
            <p className="mt-6 text-white/70 max-w-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
            <p className="mt-3 text-white/40 text-xs font-mono tracking-wider uppercase">
              {t("footer.built")}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="gc-eyebrow text-white/50">{t("footer.explore")}</p>
            <ul className="mt-5 flex flex-col gap-3">
              <li><Link to="/" className="text-white/80 hover:text-white text-sm">{t("nav.home")}</Link></li>
              <li><Link to="/despre" className="text-white/80 hover:text-white text-sm">{t("nav.about")}</Link></li>
              <li><Link to="/solutii" className="text-white/80 hover:text-white text-sm">{t("nav.solutions")}</Link></li>
              <li><Link to="/expertiza" className="text-white/80 hover:text-white text-sm">{t("nav.expertise")}</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white text-sm">{t("nav.contact")}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="gc-eyebrow text-white/50">{t("footer.contact")}</p>
            <ul className="mt-5 flex flex-col gap-3">
              <li>
                <a
                  data-testid={TID.footerEmail}
                  href={`mailto:${t("common.email")}`}
                  className="inline-flex items-center gap-2 text-white/90 hover:text-white"
                >
                  <Mail className="w-4 h-4" />
                  <span className="text-sm">{t("common.email")}</span>
                </a>
              </li>
              <li>
                <a
                  data-testid={TID.footerPhone}
                  href={t("common.phone_href")}
                  className="inline-flex items-center gap-2 text-white/90 hover:text-white"
                >
                  <Phone className="w-4 h-4" />
                  <span className="text-sm">{t("common.phone")}</span>
                </a>
              </li>
              <li className="pt-3">
                <Link
                  to="/contact"
                  className="inline-flex items-center gap-2 text-white border-b border-[color:var(--gc-red)] pb-1 text-sm hover:gap-3 transition-all"
                >
                  {t("common.cta_primary")}
                  <ArrowUpRight className="w-4 h-4" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-white/50 text-xs font-mono tracking-wider">
            {t("footer.legal").replace("{year}", year)}
          </p>
          <p className="text-white/40 text-xs font-mono tracking-wider uppercase">
            GLASSCORE · STRUCTURAL GLASS &amp; ALUMINIUM SOLUTIONS
          </p>
        </div>
      </div>
    </footer>
  );
}
